<template>
    <div>
        <dws-paylief-loading v-if="!showInvalid"></dws-paylief-loading>
        <div v-if="showInvalid" class="modal-overlay">
            <div class="modal-box">
                <h3>Session Expired</h3>
                <p style="margin-top: 20px; font-size: 1.2rem;">{{ errorMessage }}</p>
            </div>
        </div>
        <div v-if="sessionLogout" class="modal-overlay">
            <div class="modal-box">
                <h3>Session Expired</h3>
                <p style="margin-top: 20px; font-size: 1.2rem;">Please Logout from old sessions</p>
            </div>
        </div>
    </div>
</template>

<script>

import { mapActions } from 'vuex';
const crypto = require("crypto");

export default {
    data() {
        return {
            showLoader: true,
            credentials: {},
            showInvalid: false,
            sessionLogout:false,
            errorMessage:""
        }
    },

    mounted() {
        this.loading();
        // setTimeout(() => {
        //     //this.loading();
        // }, 1000);
    },

    methods: {

        ...mapActions({
            //signinUsingPassword: "auth/signinUsingPassword",
            signinUsingPassword: "auth/signinUsingDwsSsoSync",
            essigninUsingPassword: "auth/essSigninUsingDwsSsoSync",
            act_setOrgId: "onboard/organization/changeOrgId",
            // getCredentials: "auth/setCredentials"
        }),

        async decryptCredentials() {
            // let data = await this.getCredentials();
            //console.log(this.$route.query.session,process.env.VUE_ALGORITHM_KEY,process.env.VUE_CRYPTO_SECRET_KEY,process.env.VUE_APP_TIMEOUT, "?????????????");
            const encryptedEmail = this.$route.query.session;
            const key = Buffer.from(process.env.VUE_APP_CRYPTO_SECRET);
            const decryptedEmail = await this.decryptData(encryptedEmail, key);
            this.credentials = JSON.parse(decryptedEmail);
        },

        async decryptData(encryptedData, key) {
            try {
                    const algorithm = process.env.VUE_APP_ALGORITHM;
                    const iv = Buffer.from(JSON.parse(Buffer.from(encryptedData, 'base64').toString('utf-8')).iv, 'base64');
                    const encryptedText = Buffer.from(JSON.parse(Buffer.from(encryptedData, 'base64').toString('utf-8')).encryptData, 'hex');
                    const decipher = crypto.createDecipheriv(algorithm, key, iv);
                    let decrypted = decipher.update(encryptedText);
                    decrypted = Buffer.concat([decrypted, decipher.final()]);
                    return decrypted.toString();
                } catch (err) {
                    throw err;
                }
        },

        // async getAlgorithm(key) {
        //     if(!key){
        //         console.log("no key")
        //     }
        //     switch (key.length) {
        //         case 16:
        //             return 'aes-128-cbc';
        //         case 32:
        //             return 'aes-256-cbc';
        //     }
        //     throw new Error('Invalid key length: ' + key.length);
        // },

        async loading() {
            try {
                await this.decryptCredentials();
                let data 
                window.localStorage.clear()
                if(this.credentials.userRole == 'EMPLOYEE_FOR_ESS') {
                    data = await this.essigninUsingPassword(
                        { data:this.$route.query.session }
                    )
                } else {
                    data = await this.signinUsingPassword(
                        { data:this.$route.query.session }
                    )
                }
                if (data && data.status) {
                    //window.localStorage.removeItem("token");
                    window.localStorage.setItem("token", data.data.payload.token);
                    /*** START: Show the organisation according to anchor user role */
                    if (data.data.payload.userRole === 'HR' || data.data.payload.userRole === 'EMPLOYEE') {
                        let orgId = data.data.payload.org_id;
                        const permissionOrgs = data.data.payload.le_id;
                        //this.act_setOrgId(orgId);
                        //this.act_SetAuthOrgId(orgId);
                        setTimeout(() => {
                            this.$router.push({ path: `/dashboard/0/overview/feed` });
                            window.location.reload();
                        }, 100);
                    } else if (data.data.payload.userRole === 'CLIENTADMIN') {
                        // console.log(data.data.payload);
                        localStorage.setItem("empId", data.data.payload.employee_id);
                        let orgId = data.data.payload.organisations.role[0]['org_id'] ? data.data.payload.organisations.role[0]['org_id'] : data.data.payload.organisations['org_id'];
                        this.act_setOrgId(orgId)
                        setTimeout(() => {
                            this.$router.push({ path: `/clientOrgSummary` });
                            window.location.reload();
                        }, 100);
                    }
                    else {
                        setTimeout(() => {
                            this.act_setOrgId(data.data.payload.organisations.role[0]['org_id'])
                            this.$router.push({ path: "/orgSummary" });
                            // End PL_2925
                            window.location.reload();
                        }, 100);
                    }
                }
            } catch (err) {
                // if( err && err.statusCode == 403){
                    this.showInvalid = true;
                    this.errorMessage = "Login error—please contact your HR department."
                // } else{
                //     console.log("errorrrrr",err)
                //     this.showInvalid = true;
                //     this.sessionLogout = true
                //     this.errmsg = "Try Again";
                //     this.toast = true;
                // }
            }
        }
    },
}
</script>

<style lang="scss" scoped>

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: flex-start; /* Aligns to the top */
  padding-top: 30dvh;
  z-index: 9999;
}

.modal-box {
  background: white;
  padding: 24px;
  border-radius: 8px;
  min-width: 300px;
  text-align: center;
}
</style>